// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ProductGridFragmentDoc } from '../../../components/rings/product-grid/ProductGrid.generated';
import { ProductPageFacetedContentFragmentDoc } from '../../../graphql/api/product/faceted-content/productPageFacetedContent.fragment.generated';
import { ProductPageListingFragmentDoc } from '../../../graphql/api/cms/pageProductListing.fragment.generated';
import { FilterPriceRangeFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/filterPriceRange.fragment.generated';
import { MetalFilterFragmentDoc } from '../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../domain/product/useFacetedContent.generated';
import { AssetFragmentDoc } from '../../../graphql/api/fragments/asset.fragment.generated';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const JewelleryDesignStyleLabelFragmentDoc = gql`
    fragment jewelleryDesignStyleLabel on JewelleryDesignStyleLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const JewelleryDesignStyleFilterFragmentDoc = gql`
    fragment jewelleryDesignStyleFilter on CatalogueFilterJewelleryDesignStyleLabel {
  __typename
  label {
    ...jewelleryDesignStyleLabel
  }
  totalResults
}
    ${JewelleryDesignStyleLabelFragmentDoc}`;
export const JewelleryDesignFeatureLabelFragmentDoc = gql`
    fragment jewelleryDesignFeatureLabel on JewelleryDesignFeatureLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc = gql`
    fragment catalogueFilterJewelleryDesignFeatureLabel on CatalogueFilterJewelleryDesignFeatureLabel {
  __typename
  label {
    ...jewelleryDesignFeatureLabel
  }
  totalResults
}
    ${JewelleryDesignFeatureLabelFragmentDoc}`;
export const JewelleryGemstoneLabelFragmentDoc = gql`
    fragment jewelleryGemstoneLabel on JewelleryGemstoneLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const CatalogueFilterJewelleryGemstoneLabelFragmentDoc = gql`
    fragment catalogueFilterJewelleryGemstoneLabel on CatalogueFilterJewelleryGemstoneLabel {
  __typename
  label {
    ...jewelleryGemstoneLabel
  }
  totalResults
}
    ${JewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryFiltersFragmentDoc = gql`
    fragment jewelleryFilters on CatalogueJewelleriesFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
  designStyles {
    ...jewelleryDesignStyleFilter
  }
  designFeatures {
    ...catalogueFilterJewelleryDesignFeatureLabel
  }
  gemstones {
    ...catalogueFilterJewelleryGemstoneLabel
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}
${JewelleryDesignStyleFilterFragmentDoc}
${CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc}
${CatalogueFilterJewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryNecklaceProductStyleLabelFragmentDoc = gql`
    fragment jewelleryNecklaceProductStyleLabel on JewelleryNecklaceProductStyleLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const JewelleryNecklaceFiltersFragmentDoc = gql`
    fragment jewelleryNecklaceFilters on CatalogueJewelleryNecklacesFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
  productStyles {
    __typename
    label {
      ...jewelleryNecklaceProductStyleLabel
    }
    totalResults
  }
  designStyles {
    ...jewelleryDesignStyleFilter
  }
  designFeatures {
    ...catalogueFilterJewelleryDesignFeatureLabel
  }
  gemstones {
    ...catalogueFilterJewelleryGemstoneLabel
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}
${JewelleryNecklaceProductStyleLabelFragmentDoc}
${JewelleryDesignStyleFilterFragmentDoc}
${CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc}
${CatalogueFilterJewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryBraceletProductStyleLabelFragmentDoc = gql`
    fragment jewelleryBraceletProductStyleLabel on JewelleryBraceletProductStyleLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const JewelleryBraceletFiltersFragmentDoc = gql`
    fragment jewelleryBraceletFilters on CatalogueJewelleryBraceletsFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
  productStyles {
    __typename
    label {
      ...jewelleryBraceletProductStyleLabel
    }
    totalResults
  }
  designStyles {
    ...jewelleryDesignStyleFilter
  }
  designFeatures {
    ...catalogueFilterJewelleryDesignFeatureLabel
  }
  gemstones {
    ...catalogueFilterJewelleryGemstoneLabel
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}
${JewelleryBraceletProductStyleLabelFragmentDoc}
${JewelleryDesignStyleFilterFragmentDoc}
${CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc}
${CatalogueFilterJewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryEarringsProductStyleLabelFragmentDoc = gql`
    fragment jewelleryEarringsProductStyleLabel on JewelleryEarringsProductStyleLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const JewelleryEarringsFiltersFragmentDoc = gql`
    fragment jewelleryEarringsFilters on CatalogueJewelleryEarringsFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
  productStyles {
    __typename
    label {
      ...jewelleryEarringsProductStyleLabel
    }
    totalResults
  }
  designStyles {
    ...jewelleryDesignStyleFilter
  }
  designFeatures {
    ...catalogueFilterJewelleryDesignFeatureLabel
  }
  gemstones {
    ...catalogueFilterJewelleryGemstoneLabel
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}
${JewelleryEarringsProductStyleLabelFragmentDoc}
${JewelleryDesignStyleFilterFragmentDoc}
${CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc}
${CatalogueFilterJewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryRingProductStyleLabelFragmentDoc = gql`
    fragment jewelleryRingProductStyleLabel on JewelleryRingProductStyleLabel {
  systemCode
  translation(locale: $locale) {
    name
    ...facetedContentProductLabelTranslation
  }
  icon {
    ...asset
  }
}
    ${FacetedContentProductLabelTranslationFragmentDoc}
${AssetFragmentDoc}`;
export const JewelleryRingsFiltersFragmentDoc = gql`
    fragment jewelleryRingsFilters on CatalogueJewelleryRingsFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  primaryMetals {
    ...metalFilter
  }
  productStyles {
    __typename
    label {
      ...jewelleryRingProductStyleLabel
    }
    totalResults
  }
  designStyles {
    ...jewelleryDesignStyleFilter
  }
  designFeatures {
    ...catalogueFilterJewelleryDesignFeatureLabel
  }
  gemstones {
    ...catalogueFilterJewelleryGemstoneLabel
  }
}
    ${FilterPriceRangeFragmentDoc}
${MetalFilterFragmentDoc}
${JewelleryRingProductStyleLabelFragmentDoc}
${JewelleryDesignStyleFilterFragmentDoc}
${CatalogueFilterJewelleryDesignFeatureLabelFragmentDoc}
${CatalogueFilterJewelleryGemstoneLabelFragmentDoc}`;
export const JewelleryBrowseDocument = gql`
    query jewelleryBrowse($currency: CurrencyInput!, $region: RegionCode!, $filter: CatalogueJewelleriesFilterInput!, $braceletFilter: CatalogueJewelleriesBraceletsFilterInput!, $necklaceFilter: CatalogueJewelleriesNecklacesFilterInput!, $earringsFilter: CatalogueJewelleriesEarringsFilterInput!, $ringsFilter: CatalogueJewelleriesRingsFilterInput!, $isJewellery: Boolean!, $isBracelet: Boolean!, $isNecklace: Boolean!, $isEarrings: Boolean!, $isRing: Boolean!, $page: Int!, $locale: Locale!, $limit: Int = 24, $path: String!, $facetedContentInput: ProductPageFacetedContentInput!, $sortBy: CatalogueSortOrder!) {
  catalogueJewelleriesFilters(input: $filter) @include(if: $isJewellery) {
    ...jewelleryFilters
  }
  catalogueJewelleries(
    filter: $filter
    sort: {currency: $currency, by: $sortBy}
    pagination: {page: $page, limit: $limit}
  ) @include(if: $isJewellery) {
    ...productGrid
  }
  catalogueJewelleryNecklacesFilters(input: $necklaceFilter) @include(if: $isNecklace) {
    ...jewelleryNecklaceFilters
  }
  catalogueJewelleryNecklaces(
    filter: $necklaceFilter
    sort: {currency: $currency, by: $sortBy}
    pagination: {page: $page, limit: $limit}
  ) @include(if: $isNecklace) {
    ...productGrid
  }
  catalogueJewelleryBraceletsFilters(input: $braceletFilter) @include(if: $isBracelet) {
    ...jewelleryBraceletFilters
  }
  catalogueJewelleryBracelets(
    filter: $braceletFilter
    sort: {currency: $currency, by: $sortBy}
    pagination: {page: $page, limit: $limit}
  ) @include(if: $isBracelet) {
    ...productGrid
  }
  catalogueJewelleryEarringsFilters(input: $earringsFilter) @include(if: $isEarrings) {
    ...jewelleryEarringsFilters
  }
  catalogueJewelleryEarrings(
    filter: $earringsFilter
    sort: {currency: $currency, by: $sortBy}
    pagination: {page: $page, limit: $limit}
  ) @include(if: $isEarrings) {
    ...productGrid
  }
  catalogueJewelleryRingsFilters(input: $ringsFilter) @include(if: $isRing) {
    ...jewelleryRingsFilters
  }
  catalogueJewelleryRings(
    filter: $ringsFilter
    sort: {currency: $currency, by: $sortBy}
    pagination: {page: $page, limit: $limit}
  ) @include(if: $isRing) {
    ...productGrid
  }
  catalogueJewelleriesAggregate(filter: $filter) {
    count
  }
  catalogueJewelleryBraceletsAggregate(filter: $braceletFilter) {
    count
  }
  catalogueJewelleryEarringsAggregate(filter: $earringsFilter) {
    count
  }
  catalogueJewelleryNecklacesAggregate(filter: $necklaceFilter) {
    count
  }
  catalogueJewelleryRingsAggregate(filter: $ringsFilter) {
    count
  }
  pageProductListingFacetedContent(input: $facetedContentInput, locale: $locale) {
    ...productPageFacetedContent
  }
  pageProductListing(path: $path, locale: $locale) {
    ...productPageListing
  }
}
    ${JewelleryFiltersFragmentDoc}
${ProductGridFragmentDoc}
${JewelleryNecklaceFiltersFragmentDoc}
${JewelleryBraceletFiltersFragmentDoc}
${JewelleryEarringsFiltersFragmentDoc}
${JewelleryRingsFiltersFragmentDoc}
${ProductPageFacetedContentFragmentDoc}
${ProductPageListingFragmentDoc}`;

export function useJewelleryBrowseQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.JewelleryBrowseQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.JewelleryBrowseQuery, SchemaTypes.JewelleryBrowseQueryVariables | undefined>({ query: JewelleryBrowseDocument, variables: undefined, ...options });
};